import { configureIcon } from '@grapes-agency/ui'

import classes from './Icon.module.scss'

export const Icon = configureIcon({ classes })
